import React, { forwardRef, ReactElement } from 'react';
import { useMergeRefs } from '@floating-ui/react';

import { Comp, isComponent } from '@redsift/design-system';
import { useDialogContext } from '../dialog';
import { DialogTriggerProps } from './types';
import classNames from 'classnames';

const COMPONENT_NAME = 'DialogTrigger';
const CLASSNAME = 'redsift-dialog-trigger';

/**
 * The DialogTrigger component.
 */
export const DialogTrigger: Comp<DialogTriggerProps, HTMLButtonElement> = forwardRef((props, ref) => {
  const { children } = props;

  const { getReferenceProps, isOpen, handleOpen, refs, triggerClassName, color } = useDialogContext();
  const childrenRef = (children as any)?.ref;
  const triggerRef = useMergeRefs([refs.setReference, ref, childrenRef]);

  if (
    isComponent('Button')(children) ||
    isComponent('IconButton')(children) ||
    isComponent('LinkButton')(children) ||
    isComponent('Checkbox')(children) ||
    isComponent('Switch')(children) ||
    isComponent('Radio')(children) ||
    isComponent('Item')(children)
  ) {
    return React.cloneElement(children as ReactElement, {
      ...getReferenceProps({
        ref: triggerRef,
        ...props,
        ...children.props,
        children: children.props.children ?? '',
      }),
      onClick: props.onClick ? props.onClick : () => handleOpen(!isOpen),
      isActive: isOpen,
      className: classNames((children as ReactElement).props.className, triggerClassName),
      color: color ?? children.props.color,
    });
  }

  return <>{children}</>;
});
DialogTrigger.className = CLASSNAME;
DialogTrigger.displayName = COMPONENT_NAME;
